import { render } from "./stockStatistics.vue?vue&type=template&id=60e1865e&scoped=true"
import script from "./stockStatistics.vue?vue&type=script&lang=js"
export * from "./stockStatistics.vue?vue&type=script&lang=js"

import "./stockStatistics.vue?vue&type=style&index=0&id=60e1865e&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-60e1865e"

export default script